import { render, staticRenderFns } from "./AssetRegisterForm.vue?vue&type=template&id=a71d1ba6&"
import script from "./AssetRegisterForm.vue?vue&type=script&lang=js&"
export * from "./AssetRegisterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports